'use client'

export const getCookie = (name: string) => {
  if (typeof document === 'undefined') return null
  const match = document.cookie.match(`(^|;)\\s*${name}\\s*=\\s*([^;]+)`)
  return match ? match[2] : null
}

export const setCookie = (name: string, value: string, days = 365) => {
  const expires = new Date()
  expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000)
  document.cookie = `${name}=${value}; expires=${expires.toUTCString()}; path=/`
}

export const deleteCookie = (name: string) => {
  setCookie(name, '', -1)
}

export const hasAcceptedCookies = () => getCookie('cookiesAccepted') === 'true'
export const hasRejectedCookies = () => getCookie('cookiesAccepted') === 'false'
export const hasCookieChoice = () => getCookie('cookiesAccepted') !== null
export const acceptCookies = () => setCookie('cookiesAccepted', 'true')
export const rejectCookies = () => setCookie('cookiesAccepted', 'false')
